import styles from './styles.module.scss';

interface MetricBoxProps {
	label: string;
	value: string;
	highlighted?: boolean;
	className?: string;
	valueClassName?: string;
}

const MetricBox = ({ label, value, highlighted, className, valueClassName }: MetricBoxProps) => (
	<div className={`${styles.metricBox} ${highlighted ? styles.highlight : ''} ${className ?? ''}`}>
		<span className={styles.metricBoxLabel}>{label}</span>
		<span className={`${styles.metricBoxValue} ${valueClassName ?? ''}`}>
			<strong>{value}</strong>
		</span>
	</div>
);

export default MetricBox;
